import { render, staticRenderFns } from "./function.vue?vue&type=template&id=3ba8b9d6&scoped=true&"
import script from "./function.vue?vue&type=script&lang=js&"
export * from "./function.vue?vue&type=script&lang=js&"
import style0 from "./function.vue?vue&type=style&index=0&id=3ba8b9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8b9d6",
  null
  
)

export default component.exports